module.exports = __webpack_public_path__ + "static/img/detail4.ff8e12cb.png";